var $4986013c6cdfec66$exports = {};
$4986013c6cdfec66$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Pr\xf3bnik kolor\xf3w`,
    "colorSwatch": `pr\xf3bka koloru`,
    "transparent": `przezroczysty`,
    "twoDimensionalSlider": `Suwak 2D`
};


export {$4986013c6cdfec66$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
